export enum ProfileVisibility {
  PUBLIC = 'PUBLIC',
  LOGGED_IN_USERS = 'LOGGED_IN_USERS',
  PRIVATE = 'PRIVATE',
}
